export const RECORD_USER_ACTION = "RECORD_USER_ACTION"

export const recordUserAction = (params, error) => ({
  type: RECORD_USER_ACTION,
  params,
  error,
})
